import { initializeConfigFooter } from "@layout/footer";
import { initializeConfigHeader } from "@layout/header";
import { initializeConfigLogin, LoginScreenFactory } from "@layout/login";
import { initializeConfigLogout, LogoutScreenFactory } from "@layout/logout";
import { initializeConfigNotFound, NotFoundScreenFactory } from "@layout/notfound";
import { initializeConfigTokenReceiver, TokenReceiverScreenFactory } from "@layout/tokenreceiver";
import { initializeConfigChatWidget } from "@widget/chat";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { loginConfig, tokenReceiverConfig, logoutConfig, notfoundConfig, headerConfig, footerConfig, chatConfig } from "./core/config/config.initializer";
import { DEFAULT_CONFIG_CHART_WIDGET } from "./core/config/default-config";
import AuthGuard from "./core/gaurd/auth.gaurd";
import MainLayout from "./pages/main-layout/main-layout";
import ProjectBulletinPage from "./pages/project-bulletin/project-bulletin";
import { isLoggedIn } from "./core/services/user.service";
import BulletinPage from "./pages/bulletin/bulletin";
import { initializeConfigChartWidget } from "@widget/chart";

function App() {
  initializeConfigLogin(loginConfig);
  initializeConfigTokenReceiver(tokenReceiverConfig);
  initializeConfigLogout(logoutConfig);
  initializeConfigNotFound(notfoundConfig);
  initializeConfigHeader(headerConfig);
  initializeConfigFooter(footerConfig);
  initializeConfigChatWidget(chatConfig);
  initializeConfigChartWidget(DEFAULT_CONFIG_CHART_WIDGET);

  return (
    <BrowserRouter>
      <Routes>
        {/* Authenticated routes with Header and Footer */}
        <Route element={<AuthGuard isAuthenticated={isLoggedIn()} />}>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="home" element={<ProjectBulletinPage />} />
            <Route path="bulletin/:id" element={<BulletinPage />} />
          </Route>
        </Route>

        {/* Routes without Header and Footer */}
        <Route path="login" element={<LoginScreenFactory />} />
        <Route path="token-receiver" element={<TokenReceiverScreenFactory />} />
        <Route path="logout" element={<LogoutScreenFactory />} />

        {/* Not found route with Header and Footer */}
        <Route element={<MainLayout />}>
          <Route path="*" element={<NotFoundScreenFactory />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
